export type SnakeToCamelCase<S extends string> = S extends `${infer T}_${infer U}`
  ? S extends `_${infer Rest}`
    ? S extends `__${infer _}`
      ? S
      : `_${SnakeToCamelCase<Rest>}`
    : `${T}${Capitalize<SnakeToCamelCase<U>>}`
  : S;

export type CamelToSnakeCase<S extends string> = S extends `${infer T}${infer U}`
  ? U extends Uncapitalize<U>
    ? `${Uncapitalize<T>}${CamelToSnakeCase<U>}`
    : `${Uncapitalize<T>}_${CamelToSnakeCase<Uncapitalize<U>>}`
  : S;

export type CamelToSnakeCaseNested<T> = T extends (infer U)[]
  ? CamelToSnakeCaseNested<U>[]
  : T extends object
    ? {
        [K in keyof T as CamelToSnakeCase<K & string>]: CamelToSnakeCaseNested<T[K]>;
      }
    : T;

export type SnakeToCamelCaseNested<T> = T extends (infer U)[]
  ? SnakeToCamelCaseNested<U>[]
  : T extends object
    ? {
        [K in keyof T as SnakeToCamelCase<K & string>]: SnakeToCamelCaseNested<T[K]>;
      }
    : T;
